import type { ReactNode } from 'react'
import styles from './SectionEmpty.module.css'

export interface SectionEmptyProps {
  children?: ReactNode
}

export function SectionEmpty({ children }: SectionEmptyProps) {
  return <div className={styles.root}>{children}</div>
}
